import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import HomePage from './main_page/home/HomePage';
import Navbar from './main_page/Navbar';
import Footer from './main_page/Footer';
import ScrollToTop from './main_page/ScrollToTop';
import WhatsAppButton from './main_page/WhatsAppButton';
import AboutPage from './main_page/about/AboutPage';
import ServicePage from './main_page/services/ServicePage';
import CarrerPage from './main_page/carrers/CarrerPage';
import JobListingsPage from './main_page/joblistings/JobListingsPage';
import ContactUs from './main_page/contact/ContactUs';
import AcademicsPage from './main_page/academics/AcademicsPage';
import PartnersPage from './main_page/partners/PartnersPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Navbar/>
  <ScrollToTop/>
  <WhatsAppButton/>
  <Routes>
    <Route path='/' element={<HomePage/>}/>
    <Route path='/about' element={<AboutPage/>}/>
    <Route path='/services' element={<ServicePage/>}/>
    <Route path='/careers' element={<CarrerPage />} />
    <Route path='/academics' element={<AcademicsPage/>} /> 
    <Route path='/partners' element={<PartnersPage/>} /> 
    <Route path='/joblistings' element={<JobListingsPage />} />
    <Route path='contact' element={<ContactUs/>}/>
  </Routes> 
  <Footer/>
  </BrowserRouter>
);